import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { ConfigProvider, Table as UiTable } from 'antd'
import ruRU from 'antd/lib/locale/ru_RU'
import { Import } from '../../../../assets/icons'

import { TableRef } from '../../types'
import style from './style.m.less'
import { Card, CenteredSpin, IconButton } from '../../../ui'
import Filter from '../Filter/Filter'
import { getData, getFile } from '../../services'

const TableSelfRedeemed: FC<TableRef> = ({
    isLoadingOwnershipCSV,
    isLoadingOwnership,
    dataSource,
    filters,
    columns,
    pagination,
    fetchOwnership,
    fetchOwnershipCSV,
    updateFilters,
    setPagination,
}) => {
    const navigate = useNavigate()
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '16px',
                    marginTop: '16px',
                    marginBottom: '16px',
                }}
            >
                <IconButton onClick={() => navigate('/issue-ownership-certificate-self-redeemed')}>
                    Выпустить Свидетельство о возникновении прав в отношении собственных
                    производственных нужд
                </IconButton>
                <IconButton
                    disabled={isLoadingOwnershipCSV || !dataSource?.length}
                    icon={<Import />}
                    customIconStyle={{ marginRight: '8px', marginTop: '3px' }}
                    onClick={() =>
                        getFile(filters, 'certificates_ownership_own_use.csv', fetchOwnershipCSV)
                    }
                >
                    Выгрузить данные
                </IconButton>
            </div>
            <Card>
                <div style={{ marginTop: '20px' }}>
                    <div className={style.opened}>
                        <Filter onChange={updateFilters} filters={filters} />
                        {!isLoadingOwnership ? (
                            <div className={style.table}>
                                <ConfigProvider locale={ruRU}>
                                    <UiTable
                                        rowKey="id"
                                        dataSource={dataSource}
                                        columns={columns}
                                        pagination={{
                                            position: ['bottomLeft'],
                                            onChange: (page, pageSize) => {
                                                const newPag = { ...pagination, page, pageSize }
                                                setPagination(newPag)
                                                getData(newPag, fetchOwnership)
                                            },
                                            total: pagination.total,
                                            current: pagination.page,
                                            pageSize: pagination.pageSize,
                                            showSizeChanger: true,
                                        }}
                                        onRow={() => ({
                                            onClick: () => {
                                                navigate('/ownership-certificates')
                                            },
                                        })}
                                    />
                                </ConfigProvider>
                            </div>
                        ) : (
                            <CenteredSpin />
                        )}
                    </div>
                </div>
            </Card>
        </>
    )
}

export default TableSelfRedeemed
